<template>
  <div>
    <b-modal
        scrollable
      id="modal-edit-mat"
      ref="modal"
      header-class="headerModal"
      centered
      :title="addEdit ? $t('AddMaterial'): $t('EditMaterial')"
      hide-footer
      @hide="onCancel"
    >
      <b-form>
        <b-form-group
          id="input-group-1"
          :label="`${$t('Name')}:`"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="$v.form.name.$model"
            :state="validateState('name')"
            :placeholder="$t('Type')"
            aria-describedby="input-1-live-feedback"
          />
          <b-form-invalid-feedback
            id="input-1-live-feedback"
          >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="input-group-2"
          :label="`${$t('Description')}:`"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="$v.form.description.$model"
            :state="validateState('description')"
            :placeholder="$t('Type')"
            aria-describedby="input-1-live-feedback"
          />
          <b-form-invalid-feedback
            id="input-1-live-feedback"
          >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          :label="`${$t('MeasurementType')}:`"
        >
          <b-form-radio-group
            v-model="form.measurementType"
            style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px;"
          >
            <b-form-radio
              class="form-radio"
              value="Meter"
            >
              <p>{{ $t('Meter') }} </p>
            </b-form-radio>
            <b-form-radio
              class="form-radio"
              value="Part"
            >
              <p>{{ $t('Part') }} </p>
            </b-form-radio>
            <b-form-radio
              class="form-radio"
              value="Verse"
            >
              <p>{{ $t('Verse') }} </p>
            </b-form-radio>
            <b-form-radio
              class="form-radio"
              value="Package"
            >
              <p>{{ $t('Package') }} </p>
            </b-form-radio>
            <b-form-radio
              class="form-radio"
              value="Pair"
            >
              <p>{{ $t('Pair') }} </p>
            </b-form-radio>
            <b-form-radio
              class="form-radio"
              value="Set"
            >
              <p>{{ $t('Set') }} </p>
            </b-form-radio>
            <b-form-radio
              class="form-radio"
              value="Meter_Square"
            >
              <p>{{ $t('Meter_Square') }} </p>
            </b-form-radio>
          </b-form-radio-group>
          <p
            v-if="rowsLengthItem >= 1"
            style="color: red"
            class="small"
          >
            {{ $t('ChangeMeasure') }}
          </p>
        </b-form-group>
        <b-form-group />

      </b-form>
      <div class="buttonsEverywhere">
        <button
          v-if="addEdit"
          type="button"
          variant="none"
          class="buttonSubmit"

          @click="onSubmitAdd"
        >
          {{ $t('CreateBtn') }}
        </button>
        <button
          v-else
          type="button"
          variant="primary"
          class="buttonSubmit"
          @click="onSubmitEdit"
        >
          {{ $t('Submit') }}
        </button>
        <b-button
          type="button"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; ; background: white; color: black; border-color: white;font-weight: 400;"

          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>

      </div>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    editM: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    addEdit: {
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-default-prop
    rowsLengthItem: {
      type: [Number, String],
    },
    // eslint-disable-next-line vue/require-default-prop
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
      },
    }
  },
  validations: {
    form: {
      name: {
        required,
        // minLength: minLength(3),
      },
      description: {
        // required,
        // minLength: minLength(3),
      },
    },
  },

  mounted() {
    this.form = this.editM
  },

  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmitEdit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$emit('materialsEdit', this.form)
      this.$refs.modal.hide()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
    },

    onSubmitAdd() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      // alert('Form submitted!');
      this.$emit('materialsAdd', this.form)
      this.$refs.modal.hide()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
      this.onReset()
    },
    onCancel() {
      this.$refs.modal.hide()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
      this.onReset()
    },
    onReset() {
      this.form.name = ''
      this.form.description = ''
    },
  },
}
</script>

<style lang="scss" scoped>

 .form-radio{
    display:flex;
    align-items: center;
    gap:8px;
    width:100%;
  }
  .form-radio p {
    margin-bottom: 0px;
    font-size: 14px;
    white-space:nowrap;
    color:#101828;
    cursor:pointer;
  }
form {
  display: flex;
  flex-direction: column;
}
.flex-form {
    display: flex;
    flex-direction: column;
 }
.radio-form {
  flex-wrap: wrap;
}
  .aic label{
    font-size: 14px;
    color: #101828 !important;
    font-weight: 400;
    line-height: 28px;
  }
   input[type='radio']:checked:after {
        width: 15px;
        height: 15px;
        border-radius: 15px;
        top: -3px;
        left: -1px;
        position: relative;
        background-color: $base-color ;
        content: '';
        display: inline-block;
        visibility: visible;
        border: 2px solid white;
   }
  #input-group-2 {
    margin: 12px 0;
  }
</style>
